'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IfRoleDirectiveController=function(){_createClass(IfRoleDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','userService'];
}}]);

function IfRoleDirectiveController($scope,userService){var _this=this;_classCallCheck(this,IfRoleDirectiveController);
this._userService=userService;
const enabledRoles=this.role.split(',').map(function(r){return r.trim()});

$scope.$watch('controller.currentUser',function(newUser,oldUser){
if(!_.exists(newUser)){
_this.isEnabled=!1;
return;
}

if(_.exists(_this.isEnabled)&&(newUser===oldUser||newUser.role===_.get(oldUser,'role'))){
return;
}

_this.isEnabled=enabledRoles.includes(newUser.role);
});
}_createClass(IfRoleDirectiveController,[{key:'currentUser',get:function()

{
return this._userService.currentUser;
}}]);return IfRoleDirectiveController}();let


IfRoleDirective=function(_BaseControllerBacked){_inherits(IfRoleDirective,_BaseControllerBacked);function IfRoleDirective(){_classCallCheck(this,IfRoleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}IfRoleDirective.prototype.












factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.transclude=!0;
return directive;
};_createClass(IfRoleDirective,[{key:'textBindings',get:function(){return['role']}},{key:'template',get:function(){return'<ng-transclude ng-if="controller.isEnabled"/>'}},{key:'controller',get:function(){return IfRoleDirectiveController}}]);return IfRoleDirective}(BaseControllerBackedDirective);


module.exports=IfRoleDirective;
//# sourceMappingURL=ifRoleDirective.js.map
